/**
 * Setzt Klassennamen zusammen und verwirft leere Werte. Bewusst winzig gehalten —
 * eine Fremdbibliothek wäre für diesen Zweck unverhältnismäßig.
 */
export function cx(...values: (string | false | null | undefined)[]): string {
  return values.filter((value): value is string => Boolean(value)).join(' ');
}
